import type { MouseEventHandler } from 'react';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { useAuthModal } from '@shared/common/providers/GlobalModalsProvider';

import { Button } from '@ui/uikit/components/common/Button';
import { Card } from '@ui/uikit/components/common/Card';
import { Typography } from '@ui/uikit/components/common/Typography';

import type { DiscoverEngageEarnConfigItem } from '../discoverEngageEarnConfig';
import styles from './DiscoverEngageEarnCard.module.scss';

export const DiscoverEngageEarnCard = ({
  title,
  description,
  href,
  icon,
  buttonLabel,
  iconColor,
  iconBackgroundColor,
  isAuthRequired,
}: Omit<DiscoverEngageEarnConfigItem, 'id'>) => {
  const { user } = useAuth();
  const { open: openAuthModal } = useAuthModal();

  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (isAuthRequired && !user) {
      e.preventDefault();
      openAuthModal();
    }
  };

  return (
    <Card padding="large" className={styles.item}>
      <div
        className={styles.logo}
        style={{
          color: iconColor,
          background: iconBackgroundColor,
        }}
      >
        {icon}
      </div>
      <div className={styles.textBlock}>
        <Typography variant="h2" component="span">
          {title}
        </Typography>
        <Typography variant="caption-m" component="span">
          {description}
        </Typography>
      </div>
      <Button variant="secondary" size="large" href={href} onClick={handleClick}>
        {buttonLabel}
      </Button>
    </Card>
  );
};
